/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SerieLangViewModel } from "../types/SerieLangViewModel.ts";

export const serieLangViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID da tradução da série.")),
  serieId: z.optional(
    z.number().int().describe("ID da série à qual a tradução pertence."),
  ),
  title: z.string().describe("Título da série neste idioma.").nullish(),
  resumee: z
    .string()
    .describe("Resumo da série neste idioma. Opcional.")
    .nullish(),
  header: z
    .string()
    .describe("Cabeçalho da série neste idioma. Opcional.")
    .nullish(),
  cultureInfo: z
    .string()
    .describe("Código do idioma (cultura) da tradução.")
    .nullish(),
  cultureDisplayName: z
    .string()
    .describe("Nome amigável do idioma da tradução.")
    .nullish(),
}) as unknown as ToZod<SerieLangViewModel>;
